import { Modal } from '@arcadiapower/shrike';
import styled from 'styled-components';

export const StyledDialogModal = styled(Modal)`
  [data-reach-dialog-content] {
    overflow-x: hidden;
    position: fixed;
    padding-bottom: 0px;
  }
`;

export const IconWrapper = styled.div`
  margin-bottom: 24px;
`;
